<style>

</style>
<template>
  <div ref="echart" v-resize="onResize" style="width: inherit; height: inherit"/>
</template>
<script>
// import echarts from 'echarts/';
import * as echarts from 'echarts/dist/echarts.js';
echarts.registerMap('nigeria', require('@/components/charts/echart/map/data/nigeria.json'));
export default {
    props:['chart', 'module', "chartId"],
    data: function() {
      return {};
    },
    methods: {
      rendered: function() {

      },
      onResize: function() {
        // console.log("resized");
        if(this.chart && typeof this.chart.thisEChart != 'undefined') {
          this.chart.refs = this.$refs;
          // console.log("resized");
          this.chart.thisEChart.resize();
          //
        }

        try {
          this.module.resize(this.chartId, this.$refs.echart);
        } catch(error) {

        }
      }
    },
    computed: {

    },
    components: {

    },
    mounted: function() {
      

      console.log("draw chart");
      if(this.chart && typeof this.chart.draw != "undefined") {
        this.chart.refs = this.$refs;
        this.chart.uiLoaded = false;
        this.chart.draw();
        console.log("draw chart 2");
      }

      try {

      } catch(error) {
      } 
      if(this.module) {
        if(typeof this.module.echarts == "undefined") {
          this.module.echarts = echarts;
        }
        
        // try {
        //   this.module.charts[this.key].ref = this.$refs.echart;
        //   this.module.charts[this.key].draw();
        // } catch(error) {
          
          if(typeof this.module.draw != "undefined") {
            if(this.chartId) {
              this.module.draw(this.chartId, this.$refs.echart);
            } else {
              this.module.refs = this.$refs;
              this.module.ref = this.$refs.echart;
              this.module.draw();
            }
            
          }
        
      }



    }
}

</script>
